import { render } from "./Skeleton.vue?vue&type=template&id=539279bd&scoped=true"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=539279bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539279bd"]])

export default __exports__